import { render, staticRenderFns } from "./OtherLiveRoom.vue?vue&type=template&id=53d00973&scoped=true"
import script from "./OtherLiveRoom.vue?vue&type=script&lang=js"
export * from "./OtherLiveRoom.vue?vue&type=script&lang=js"
import style0 from "./OtherLiveRoom.vue?vue&type=style&index=0&id=53d00973&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53d00973",
  null
  
)

export default component.exports